import React, { useState, useEffect } from "react";
import moment from "moment";

const CertifyStudentsTrainerVersionHistorySection = (props) => {
    const [certifications, setCertifications] = useState([]);

    const groupCertifications = (certifications) => {
        const grouped = {};

        certifications.forEach((certificate) => {
            const userKey = certificate.user?.uuid;
            const createdTime = certificate.created;

            // extract only date (yyyy-mm-dd) from createdTime
            const dateOnly = createdTime.split("T")[0];
            const key = `${userKey}-${dateOnly}`;

            if (!grouped[key]) {
                grouped[key] = [];
            }

            grouped[key].push(certificate);
        });

        return grouped;
    };

    useEffect(() => {
        setCertifications(groupCertifications(props.certifications));
    }, [props.certifications]);

    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th>NIBHV nummer</th>
                        <th>Naam</th>
                        <th>Fysieke pas</th>
                        <th>Aangevraagde certificeringen</th>
                        <th>Aangevraagd</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.values(certifications).map((certificateGroup, index) => {
                        const firstCertificate = certificateGroup[0];

                        return (
                            <tr key={index}>
                                <td>{firstCertificate.user?.nibhv_number}</td>
                                <td>{firstCertificate.user?.full_name}</td>
                                <td>
                                    {certificateGroup.map((certificate) => (
                                        <div key={certificate.uuid}>
                                            <i
                                                style={{ color: certificate.physical_pass ? "green" : "red" }}
                                                className={`fa fa-${certificate.physical_pass ? "check" : "times"}`}
                                            />
                                        </div>
                                    ))}
                                </td>
                                <td>
                                    {certificateGroup.map((certificate) => (
                                        <div key={certificate.uuid}>{certificate.competence_profile?.name}</div>
                                    ))}
                                </td>
                                <td>
                                    {moment(firstCertificate.created).format("[Op] DD-MM-YYYY [om] HH:mm")} door {firstCertificate?.created_by?.full_name}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <hr />
        </>
    );
};

export default CertifyStudentsTrainerVersionHistorySection;
